<app-default-layout
  [title]="'AUTHENTICATION.KENNWORT_AENDERN.TITLE'"
  [subtitle]="'AUTHENTICATION.KENNWORT_AENDERN.SUBTITLE'"
>


  <div class="row">
    <div class="col-md-8 offset-md-2">
      <form  [formGroup]="kennwortAenderungForm" (ngSubmit)="this.save()" class="form-horizontal"
             accept-charset="UTF-8">

        <div class="form-group group-for-kennwort col mb-4">

          <div class="d-flex flex-row" style="margin-bottom: -15px">
            <div class="flex-grow-1 mr-2">

              <app-custom-input id="kennwort" type="text"
                                [type] = "pwHide? 'password':'text'"
                                class="flex-grow-1"
                                label="{{'REGISTRIERUNG.PW' |translate }}"
                                [customFormGroup]="kennwortAenderungForm"
              ></app-custom-input>
            </div>
            <fa-icon  style="margin-left: -25px; padding-top: 17px; margin-top: 15px; width: 26px; z-index:1"
                      [icon]="pwHide? faEye:faEyeSlash" (click) = "pwHide=!pwHide"
                      [title]="pwHide? translate.instant('LOGIN.PW-SHOW'):translate.instant('LOGIN.PW-HIDE')"
                      data-cy="btn-pwhide">
            </fa-icon>
          </div>
        </div>

        <button type="submit"
                class="btn btn-primary save btn-block me-3"
                data-cy="btn-submit">
          {{'APPLICATION.BUTTON_SPEICHERN'|translate}}
        </button>

      </form>
    </div>
  </div>


</app-default-layout>
